var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { t } from '@mp/locale';
import { useEffect, useState } from "react";
import Button from '../../button';
import Cookies from "js-cookie";
import "./property-styles.scss";
import CaptureRequirements from '../CaptureRequirements/CaptureRequirements';
export default function PropertySpaceSelector(_a) {
    var backStep = _a.backStep, captureType = _a.captureType, handleTracking = _a.handleTracking, nextStep = _a.nextStep, propertyType = _a.propertyType, setCaptureType = _a.setCaptureType, setPropertyType = _a.setPropertyType, props = __rest(_a, ["backStep", "captureType", "handleTracking", "nextStep", "propertyType", "setCaptureType", "setPropertyType"]);
    var _b = useState(true), selected = _b[0], setSelected = _b[1];
    var session = sessionStorage.getItem("order-details");
    var cookie = Cookies.get('capture_service_address');
    useEffect(function () {
        var orderDetails = JSON.parse(session) || null;
        // Prioritize session storage
        if (orderDetails && (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.property_type)) {
            if (orderDetails.property_type.toLowerCase() === "residential") {
                setSelected(true);
                setPropertyType("Residential");
            }
            else {
                setSelected(false);
                setPropertyType("Commercial");
            }
            return;
        }
        if (cookie) {
            var cookieDetails = JSON.parse(cookie);
            if ((cookieDetails === null || cookieDetails === void 0 ? void 0 : cookieDetails.property_type.toLowerCase()) === "residential") {
                setSelected(true);
                setPropertyType("Residential");
            }
            if ((cookieDetails === null || cookieDetails === void 0 ? void 0 : cookieDetails.property_type.toLowerCase()) === "commercial") {
                setSelected(false);
                setPropertyType("Commercial");
            }
        }
    }, [cookie, session]);
    var changeType = function (ev) {
        if (ev === "Residential") {
            setSelected(true);
            setPropertyType("Residential");
        }
        else {
            setSelected(false);
            setPropertyType("Commercial");
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("p", __assign({ "data-qa": "property-details-title", className: "mp-capturesvc-step-subtitle" }, { children: [" ", t("CAPTURE_SERVICES.ORDER.PROPERTY_SIZE.subtitle"), " "] })), _jsxs("div", __assign({ "data-qa": "property-type-radio", className: "capture-service-property-radio-container", onChange: function (ev) { return changeType(ev.target.value); } }, { children: [_jsxs("label", { children: [_jsx("input", { className: "capture-service-radio-input", type: "radio", onClick: handleTracking, name: "type", checked: selected, value: "Residential" }), _jsxs("div", __assign({ className: "capture-services-radio" }, { children: [_jsx("span", __assign({ className: "capture-services-capture-radio" }, { children: _jsx("span", {}) })), _jsxs("p", { children: [" ", t("CAPTURE_SERVICES.PROPERTY_TYPES.RESIDENTIAL"), " "] })] }))] }), _jsxs("label", { children: [_jsx("input", { className: "capture-service-radio-input", onClick: handleTracking, type: "radio", name: "type", checked: !selected, value: "Commercial" }), _jsxs("div", __assign({ className: "capture-services-radio" }, { children: [_jsx("span", __assign({ className: "capture-services-capture-radio" }, { children: _jsx("span", {}) })), _jsx("p", { children: t("CAPTURE_SERVICES.PROPERTY_TYPES.COMMERCIAL") })] }))] })] })), _jsx(CaptureRequirements, { captureType: captureType, handleTracking: handleTracking, propertyType: propertyType, setCaptureType: setCaptureType }), _jsxs("div", __assign({ className: "position-right" }, { children: [_jsx(Button, { className: "margin-right-20", dark: true, "data-qa": "property-type-return-button", onClick: backStep, label: t("CAPTURE_SERVICES.SCHEDULER.back"), buttonType: "secondary", htmlId: "property-type-return-button" }), _jsx(Button, { "data-qa": "address-confirmed-button", dark: true, label: t("CAPTURE_SERVICES.SCHEDULER.next"), onClick: nextStep, buttonType: "primary", htmlId: "address-confirmed-button" })] }))] }));
}
